<template>
  <v-dialog max-width="750" v-model="show" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">{{ dialogTitle }}</v-card-title>
      <v-container grid-list-md fluid>
        <v-layout wrap>
          <v-flex>
            <v-text-field label="Name" v-model="supplierName"></v-text-field>
          </v-flex>
          <v-flex>
            <v-text-field label="Code" v-model="code"></v-text-field>
          </v-flex>
          <v-flex>
            <head-office-list-select
              v-model="headOfficeId"
            ></head-office-list-select>
          </v-flex>
          <v-flex>
            <v-text-field label="Email" v-model="email"></v-text-field>
          </v-flex>
          <v-flex>
            <currency-list-select v-model="currency"></currency-list-select>
          </v-flex>
          <v-flex>
            <rate-type-list-select
              @onSelect="onRateTypeSelect"
              hideNotInUse
            ></rate-type-list-select>
          </v-flex>
          <v-flex xs12 v-if="false">
            <supplier-type-radios v-model="supplierType"></supplier-type-radios>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="debug">
        currency: {{ currency }}, headOfficeId: {{ headOfficeId }}, destination:
        {{ defaultDestination }}
      </div>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="$emit('close')" color="warning" text>Close</v-btn>
        <v-btn
          :disabled="!isValid || loading"
          :loading="loading"
          color="primary"
          @click="onCreate"
          >Create</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SupplierTypeRadios from "../shared/SupplierTypeRadios";
import CurrencyListSelect from "../shared/CurrencyListSelect";
import HeadOfficeListSelect from "../shared/HeadOfficeListSelect";
import RateTypeListSelect from "../shared/RateTypeListSelect";
import gql from "graphql-tag";
const CREATE_ADHOC_SUPPLIER = gql`
  mutation ($supplierInput: SupplierInput!) {
    createSupplier(supplierInput: $supplierInput) {
      id
    }
  }
`;
export default {
  name: "AdhocSupplier",
  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    defaultSupplierType: {
      type: String,
    },
    defaultDestination: {
      type: String,
      default: () => "",
    },
    defaultSupplierName: {
      type: String,
      default: () => "",
    },
  },
  components: {
    SupplierTypeRadios,
    CurrencyListSelect,
    HeadOfficeListSelect,
    RateTypeListSelect,
  },
  data() {
    return {
      debug: false,
      supplierName: this.defaultSupplierName
        ? this.defaultSupplierName
        : "New Supplier",
      code: "",
      email: "",
      supplierType: "ACCOMMODATION",
      currency: "",
      headOfficeId: "",
      loading: false,
      rateType: "",
    };
  },
  watch: {
    show() {
      //reset
      this.supplierName = "";
      this.code = "";
      this.email = "";
    },
    defaultSupplierType(newType) {
      this.supplierType = newType;
    },
    defaultSupplierName(newName) {
      this.supplierName = newName;
    },
  },
  computed: {
    dialogTitle() {
      return this.supplierName != "" ? this.supplierName : "Adhoc Supplier";
    },
    isValid() {
      return (
        this.supplierName != "" &&
        this.code != "" &&
        this.currency != "" &&
        this.rateType != ""
      );
    },
  },
  methods: {
    onRateTypeSelect(event) {
      this.rateType = event;
    },
    onCreate() {
      this.$emit("adhoc-create", {
        name: this.supplierName,
        code: this.code,
        email: this.email,
        headOfficeId: this.headOfficeId,
        serviceType: this.supplierType,
        currencyCode: this.currency,
        notInUse: false,
        destinationId: this.defaultDestination,
        defaultRateTypeCode: this.rateType ? this.rateType.code : "",
      });
      // this.loading = true;
      // this.$apollo
      //   .mutate({
      //     mutation: CREATE_ADHOC_SUPPLIER,
      //     variables: {
      //       supplierInput: {
      //         name: this.supplierName,
      //         code: this.code,
      //         email: this.email,
      //         headOfficeId: this.headOfficeId,
      //         serviceType: this.supplierType,
      //         currencyCode: this.currency,
      //         notInUse: false,
      //         destinationId: this.defaultDestination
      //       }
      //     },
      //     update: (store, { data }) => {
      //       console.log(store, data);
      //       //const data = store.readQuery({ query: TAGS_QUERY });

      //       //store.writeQuery({ query: TAGS_QUERY, data });
      //     }
      //   })
      //   .then(result => {
      //     this.$store.dispatch("showAppSnackbar", { msg: "Supplier Created." });
      //     this.loading = false;
      //     //this.$emit("adhoc-create", result);
      //   })
      //   .catch(err => {
      //     console.error(err);
      //     this.loading = false;
      //   });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/AdhocSupplier.vue